var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SfInputSearch',{directives:[{name:"debounce",rawName:"v-debounce:400ms",value:(_vm.searchChange),expression:"searchChange",arg:"400ms"}],attrs:{"placeholder":_vm.showBy === 'loop'
      ? 'Search loop'
      : _vm.showBy === 'campaign'
      ? 'Search campaign'
      : _vm.capitalizeFirstLetter([_vm.$t('search'), _vm.$t('player')]),"height":'40px'},on:{"onSearchInputChange":_vm.onSearchInputChange},model:{value:(_vm.searchValue),callback:function ($$v) {_vm.searchValue=$$v},expression:"searchValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }